export const QUESTIONS_DATA = {
  "sections": [
    {
      "id": 1,
      "title": "Sektion 1: Wärme und Lüftung",
      "questions": [
        {
          "id": 1,
          "text": "Ist gewährleistet, dass trotz Staubschutz-Abdeckungen die Kaltluftzufuhr zu den Servern und der Warmluftabzug physikalisch ungehindert funktionieren?",
          "info": "Die Abdeckung aktiver Hardware mit Folien kann zu einem Wärmestau führen und in der Folge Hardwareschäden verursachen."
        },
        {
          "id": 2,
          "text": "Ist die Ansaugung der Raumklimageräte mit Vorfiltern gegen Baustaub geschützt, ohne die Lüftung kritisch zu drosseln?",
          "info": "Klimageräte fungieren bei Bauarbeiten wie Staubsauger. Ohne spezialisierte Vorfilterung setzt sich der Feinstaub in den Wärmetauschern fest, was die Kühlleistung reduziert und die Betriebskosten sowie das Ausfallrisiko erhöht."
        },
        {
          "id": 3,
          "text": "Werden Arbeiten am Doppelboden ausgeführt und ist sichergestellt, dass der Druck im Hohlboden für die Serverkühlung nicht geschwächt wird?",
          "info": "In vielen Rechenzentren dient der Hohlboden für die Kaltluftzufuhr. Abgedeckte Bodenplatten während der Bauphase führen zu einem Druckabfall, wodurch die Luftkühlung reduziert werden kann."
        }
      ]
    },
    {
      "id": 2,
      "title": "Sektion 2: Der physikalische Schutz und Staubarten",
      "questions": [
        {
          "id": 4,
          "text": "Gibt es eine physische Trennung (Staubschutzwand/Schleuse) zwischen Baustelle und Reinraum/Serverraum?",
          "info": "Da Staubpartikel – insbesondere Gips- und Zementstaub (mit Feuchtigkeit werden chemische Reaktionen in der Elektronik erzeugt) muss eine klare Zonentrennung erfolgen. Ein Staubschutzsystem verhindert die Verschleppung von Partikeln durch Luftzüge und Personenverkehr in den sensiblen Technikbereich."
        },
        {
          "id": 5,
          "text": "Wird im Baustellenbereich mit Unterdruck (Absaugung) gearbeitet, um zu verhindern, dass Staub in den angrenzenden sauberen Serverraum (Überdruck) gedrückt wird?",
          "info": "Durch ein gezieltes Druckgefälle stellen Sie sicher, dass Luftströme stets vom sauberen IT-Bereich in Richtung Baustelle fliessen. Dies ist die effektivste Methode, um die Migration von Feinstaub in sensible Zonen durch kleinste Öffnungen zu unterbinden."
        },
        {
          "id": 6,
          "text": "Sind Kabeldurchführungen (Schottungen) und Türspalten zu angrenzenden Baubereichen hermetisch abgedichtet?",
          "info": "Baustaub in der Peripherie führt zu Verunreinigungen, weil ein absoluter Schutz nicht möglich ist. Besonders Kabeltrassen und Brandabschottungen sind häufige Schwachstellen, über die technische Anlagen unbemerkt kontaminiert werden."
        }
      ]
    },
    {
      "id": 3,
      "title": "Sektion 3: Etagenverteiler und Dezentrale Technik",
      "questions": [
        {
          "id": 7,
          "text": "Sind die technischen Räume gegen Bohrstaub bei Kernbohrungen geschützt, bevor diese beginnen?",
          "info": "Dezentrale Infrastruktur wie Etagenverteiler wird im Staubschutzkonzept oft übersehen. Da diese Schränke meist über aktive Lüftungsschlitze verfügen, saugen sie Bohrstaub direkt an und können zu Verunreinigungen der Platinen führen."
        },
        {
          "id": 8,
          "text": "Haben Handwerker freien Zugang zu Räumen mit Hardware und ist dokumentiert, wer wann Zutritt hatte?",
          "info": "Unkontrollierter Zugang erhöht das Risiko für mechanische Beschädigungen oder versehentliche Manipulationen an der Verkabelung (z.B. versehentliches Ziehen von Steckern). Ein definierter Zugang stellt sicher, dass ausschliesslich autorisierte Personen Zutritt haben und alle Zugriffe nachvollziehbar sind."
        }
      ]
    },
    {
      "id": 4,
      "title": "Sektion 4: Notfall und Dokumentation",
      "questions": [
        {
          "id": 9,
          "text": "Sind Brandmelder während staubintensiver Arbeiten temporär angepasst oder deaktiviert worden, um Fehlalarme zu vermeiden?",
          "info": "Feinstaubpartikel werden von vielen Rauchmeldern als Brandrauch interpretiert. Um kostspielige Feuerwehreinsätze und die damit verbundene Unterbrechung des Baubetriebs zu vermeiden, muss die Brandmeldeanlage (BMA) prozessbegleitend koordiniert werden."
        },
        {
          "id": 10,
          "text": "Gibt es eine 24/7-Nummer für eine Sofort-Instandstellung der Elektronik, falls eine Staub-Kontamination passiert?",
          "info": "Bei Verunreinigung der ICT ist die Reaktionszeit entscheidend. Ein Notfall-Plan stellt sicher, dass kontaminierte Systeme umgehend fachgerecht gereinigt werden, bevor chemische Reaktionen oder Kurzschlüsse die Hardware dauerhaft schädigen."
        },
        {
          "id": 11,
          "text": "Wird der Zustand der Reinheit nach Abschluss der Arbeiten gemessen und protokolliert?",
          "info": "Ein professionelles Status-Zertifikat mit dokumentierten Messwerten (z.B. nach ISO 14644-8) dient als rechtssicherer Nachweis für die ordnungsgemässe Übergabe an den Bauherrn und schützt Sie vor späteren Regressforderungen."
        }
      ]
    }
  ],
  "scoring": {
    "green": {
      "min": 0,
      "max": 2,
      "label": "GRÜN",
      "title": "Grüner Bereich (Vorbildlich)",
      "description": "Ihre Baustelle ist technisch gut organisiert. Das Risiko für IT-Ausfälle ist minimal.",
      "recommendation": "Wir senden Ihnen zur Dokumentation dennoch den vollständigen Leitfaden zu, um Ihren hohen Standard beizubehalten."
    },
    "yellow": {
      "min": 3,
      "max": 5,
      "label": "GELB",
      "title": "Gelber Bereich (Erhöhtes Risiko)",
      "description": "Vorsicht. Es bestehen kritische Lücken in Ihrem Schutzkonzept, insbesondere bei der Kühlung oder den Zutrittswegen.",
      "recommendation": "Baustaub könnte bereits in die Peripherie eingedrungen sein. Wir empfehlen eine visuelle Kontrolle der IT-Komponenten."
    },
    "red": {
      "min": 6,
      "max": 11,
      "label": "ROT",
      "title": "Roter Bereich (Handlungsbedarf)",
      "description": "Ihre aktiven Systeme sind höchstwahrscheinlich ungeschützt dem Baustaub ausgesetzt. Das Risiko für sporadische Störungen, Kontaktfehler und ungewöhnliches Systemverhalten ist akut.",
      "recommendation": "In diesem Zustand tragen Sie ein Haftungsrisiko für die Anlagen des Bauherrn. Sofortige Massnahmen sind dringend erforderlich."
    }
  }
};